import { render, staticRenderFns } from "./quickEntrance.vue?vue&type=template&id=6269f773&scoped=true"
import script from "./quickEntrance.vue?vue&type=script&lang=js"
export * from "./quickEntrance.vue?vue&type=script&lang=js"
import style0 from "./quickEntrance.vue?vue&type=style&index=0&id=6269f773&lang=scss"
import style1 from "./quickEntrance.vue?vue&type=style&index=1&id=6269f773&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6269f773",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6269f773')) {
      api.createRecord('6269f773', component.options)
    } else {
      api.reload('6269f773', component.options)
    }
    module.hot.accept("./quickEntrance.vue?vue&type=template&id=6269f773&scoped=true", function () {
      api.rerender('6269f773', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/newMenu/quickEntrance.vue"
export default component.exports